import { Environments } from './../enums/enivronments';
import { MenuItem } from './../classes/menuItem';

/**
 * @TODO: Some menu items are hidden temporary!!!
 */
export default MenuItem.toCollection([
    // {
    //     path: '/',
    //     icon: 'el-icon-data-analysis',
    //     label: 'menu.dashboard',
    // },
    {
        path: '/search-contact',
        icon: 'el-icon-search',
        label: 'menu.records',
        allow: [Environments.LOCAL, Environments.INTERNAL, Environments.STAGING, Environments.PRODUCTION],
    },
    {
        path: '/properties',
        icon: 'el-icon-notebook-2',
        label: 'menu.properties',
        allow: [Environments.LOCAL, Environments.INTERNAL, Environments.STAGING, Environments.PRODUCTION],
    },
    {
        path: '/integrations',
        icon: 'el-icon-connection',
        label: 'menu.integrations',
        allow: [Environments.LOCAL, Environments.INTERNAL, Environments.STAGING, Environments.PRODUCTION],
    },
    {
        path: '/devices',
        icon: 'el-icon-mobile-phone',
        label: 'menu.devices',
        allow: [Environments.LOCAL, Environments.INTERNAL, Environments.STAGING, Environments.PRODUCTION],
    },
    {
        path: '/api-keys',
        icon: 'el-icon-unlock',
        label: 'menu.apiKeys',
        allow: [Environments.LOCAL, Environments.INTERNAL, Environments.STAGING, Environments.PRODUCTION],
    },
    {
        path: '/profile',
        icon: 'el-icon-user',
        label: 'menu.profile',
        allow: [Environments.LOCAL, Environments.INTERNAL, Environments.STAGING, Environments.PRODUCTION],
    },
    {
        path: '/calls',
        icon: 'el-icon-phone-outline',
        label: 'menu.callHistory',
        allow: [Environments.LOCAL, Environments.INTERNAL, Environments.STAGING, Environments.PRODUCTION],
    },
    {
        path: 'none',
        icon: 'el-icon-setting',
        label: 'menu.settings',
        allow: [Environments.LOCAL, Environments.INTERNAL, Environments.STAGING, Environments.PRODUCTION],
        childrens: [
            {
                path: '/plan',
                icon: 'el-icon-box',
                label: 'menu.plan',
            },
            {
                path: '/payment-settings',
                icon: 'el-icon-wallet',
                label: 'menu.paymentSettings',
                hideForShopify: true,
            },
            {
                path: '/invoices',
                icon: 'el-icon-notebook-1',
                label: 'menu.invoices',
                hideForShopify: true,
            },
            {
                path: '/billing',
                icon: 'el-icon-tickets',
                label: 'menu.billing',
                hideForShopify: true,
            },
        ],
    },
    {
        path: '/contact',
        icon: 'el-icon-message',
        label: 'menu.contact',
        allow: [Environments.LOCAL, Environments.INTERNAL, Environments.STAGING, Environments.PRODUCTION],
    },
    {
        path: '/logout',
        icon: 'el-icon-upload2',
        label: 'menu.logout',
        allow: [Environments.LOCAL, Environments.INTERNAL, Environments.STAGING, Environments.PRODUCTION],
    },
    {
        path: '/help',
        icon: 'el-icon-question',
        label: 'menu.help',
        allow: [Environments.LOCAL, Environments.INTERNAL, Environments.STAGING, Environments.PRODUCTION],
    },
]);
